import type {TypedSchema} from 'schemaDefinition/types';
import type {OverviewTask} from 'services/tasks/types';

export const taskSchema: TypedSchema<OverviewTask> = {
  name: 'task',
  key: 'task',
  parts: [
    {
      type: 'text',
      name: 'lockedBy',
    },
    {
      type: 'text',
      name: 'id',
    },
    {
      type: 'text', //codelist
      name: 'taskTypes',
      //codelistId: 'task_type',
    },
    {
      type: 'text',
      name: 'manifestationId',
    },
    {
      type: 'text',
      name: 'workId',
    },
    {
      type: 'text',
      name: 'isbn',
      key: 'isbn',
    },
    {
      type: 'text',
      name: 'ean',
      key: 'ean',
    },
    {
      type: 'text',
      name: 'mainTitle',
      key: 'mainTitle',
    },
    {
      type: 'text',
      name: 'mainAgent',
      key: 'mainAgent',
    },
    {
      type: 'text',
      name: 'productOwner',
    },
    {
      type: 'text',
      name: 'productOwnerName',
    },
    {
      type: 'text',
      name: 'productOwnerCode',
    },
    {
      type: 'codelist',
      name: 'productForm',
      codelistId: 'PRODUCT_FORM',
      showCode: true,
    },
    {
      type: 'date',
      name: 'publisherSalesDate',
      key: 'publisherSalesDate',
    },
    {
      type: 'date',
      name: 'inSaleDate',
      key: 'inSaleDate',
    },
    {
      type: 'codelist',
      name: 'availabilityStatus',
      codelistId: 'availability_status',
    },
    {
      type: 'date',
      name: 'contentReceivedDate',
      key: 'contentReceivedDate',
    },
    {
      type: 'codelist',
      name: 'media',
      codelistId: 'media_sub_type',
      cardinality: 'multiple',
    },
    {
      type: 'text',
      name: 'searchableTaskString',
    },
    {
      type: 'text',
      name: 'registered',
    },
  ],
};
